/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GoogleApiHttpBodyFromJSON, GoogleApiHttpBodyToJSON, } from './';
export function StreemInternalApiCreateUserAssetRequestFromJSON(json) {
    return StreemInternalApiCreateUserAssetRequestFromJSONTyped(json, false);
}
export function StreemInternalApiCreateUserAssetRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'companyCode': !exists(json, 'company_code') ? undefined : json['company_code'],
        'httpBody': !exists(json, 'http_body') ? undefined : GoogleApiHttpBodyFromJSON(json['http_body']),
        'filename': !exists(json, 'filename') ? undefined : json['filename'],
    };
}
export function StreemInternalApiCreateUserAssetRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'company_code': value.companyCode,
        'http_body': GoogleApiHttpBodyToJSON(value.httpBody),
        'filename': value.filename,
    };
}
//# sourceMappingURL=StreemInternalApiCreateUserAssetRequest.js.map